import component from './LayoutManage.vue'
export default component
